module.exports = __webpack_public_path__ + "static/img/social_widget_3.47ec308.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/social_widget_3.png
// module id = y23w
// module chunks = 11